import {
  getParcelAlertLabel,
  getParcelItemsQuantity,
  getParcelSenderName,
  getParcelSequenceInfo,
} from '@/parcels/helpers/helpers'

import ParcelCard from './ParcelCard/ParcelCard'
import * as Styles from './styles'

const ParcelsCards = ({
  parcels,
  onSelect,
  selectedParcels,
  getParcelDetailHref,
  onParcelDetailClick,
  parcelDetailSelectedId,
}) => {
  const isSelected = id => selectedParcels.map(parcel => parcel.id).includes(id)

  return (
    <Styles.ParcelsCardsContainer data-testid="parcels-cards">
      {parcels?.results?.map(parcel => (
        <ParcelCard
          key={parcel.id}
          id={parcel.id}
          orderName={parcel.order?.name}
          withCustoms={parcel.related?.with_customs}
          senderAddress={parcel?.origin}
          senderName={getParcelSenderName(parcel)}
          recipientAddress={parcel.related?.recipient_address}
          destinationAddress={parcel?.destination}
          trackingNumber={parcel.tracking_number}
          trackingUrl={parcel.order?.order_tracking_page_url}
          status={parcel.status}
          createdAt={parcel.created_at}
          modifiedAt={parcel.modified_at}
          itemsQuantity={getParcelItemsQuantity(parcel)}
          notes={parcel.related?.notes}
          customer={parcel.customer_profile}
          carrierName={parcel.carrier?.name}
          carrierLogo={parcel.carrier?.logo_url}
          shippingMethod={parcel.method}
          error={getParcelAlertLabel(parcel)}
          email={parcel.order?.email}
          selected={isSelected(parcel.id)}
          onSelect={() => onSelect(parcel.id)}
          getParcelDetailHref={getParcelDetailHref}
          onParcelDetailClick={onParcelDetailClick}
          parcelDetailSelectedId={parcelDetailSelectedId}
          sequenceInfo={getParcelSequenceInfo(parcel)}
          pickupDate={parcel.pickup_scheduled}
          type={parcel.type}
          isExchange={parcel.order?.is_exchange}
        />
      ))}
    </Styles.ParcelsCardsContainer>
  )
}

export default ParcelsCards
